import { ReactElement, PropsWithChildren } from "react";

import PageHeader from "global-components/pageHeader/PageHeader";
import PageFooter from "global-components/pageFooter/PageFooter";

import styles from "./auth-page-template.module.css";

const AuthPageTemplate = ({
  children,
  header,
  addTermsAndConditions = false,
}: PropsWithChildren<{
  header?: {
    title: string;
    subTitle?: ReactElement;
    description: string | ReactElement;
    icon?: ReactElement;
  };
  addTermsAndConditions?: boolean;
}>): ReactElement => {
  return (
    <div>
      <div className={styles.mainContent}>
        {header && (
          <>
            {header.icon && (
              <div className={styles.headerIcon}>{header.icon}</div>
            )}

            <div className={styles.pageHeader}>
              <PageHeader
                title={header.title}
                subTitle={header.subTitle}
                description={header.description}
                largeTitle={true}
              />
            </div>
          </>
        )}

        {children}
      </div>
      <PageFooter addTermsAndConditions={addTermsAndConditions} />
    </div>
  );
};

export default AuthPageTemplate;
